module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"filelist-item\">\n    <a type=\"")
    ; __append(escapeFn( item.mime ))
    ; __append("\" download=\"")
    ; __append(escapeFn( item.name ))
    ; __append("\" href=\"")
    ; __append(escapeFn( url ))
    ; __append(escapeFn( item.mainpath ))
    ; __append("\" target=\"_blank\">\n		<span class=\"icon fiv-cla fiv-icon-")
    ; __append(escapeFn( item.name.split('.').pop()))
    ; __append("\"></span> ")
    ; __append(escapeFn(item.name))
    ; __append("</a>\n	")
    ;  if (item.humansize) { 
    ; __append("\n		(")
    ; __append(escapeFn( item.humansize ))
    ; __append(")\n	")
    ;  } 
    ; __append("\n    ")
    ;  if (typeof readonly == "undefined" || !readonly) { 
    ; __append("\n    <span class=\"filelist-delete\" data-id=\"")
    ; __append(escapeFn( item.id ))
    ; __append("\"></span>\n    ")
    ;  } 
    ; __append("\n</div>\n")
  }
  return __output.join("");

}